import type { BadgeProps } from '@/components/ui/badge';

type Translate = (key: string, fallback: string) => string;

/**
 * MUI's Chip `default` colour was its grey fallback rather than a palette
 * entry, so it maps to the secondary badge, not to a status colour.
 */
export const getStatusVariant = (status: string): BadgeProps['variant'] => {
  switch (status) {
    case 'completed':
      return 'success';
    case 'processing':
    case 'analyzing':
      return 'warning';
    case 'failed':
      return 'destructive';
    default:
      return 'secondary';
  }
};

export const getStatusLabel = (status: string, t: Translate): string => {
  switch (status) {
    case 'completed':
      return t('drbfm.history.statusCompleted', '完了');
    case 'processing':
    case 'analyzing':
      return t('drbfm.history.statusProcessing', '処理中');
    case 'failed':
      return t('drbfm.history.statusFailed', '失敗');
    case 'draft':
      return t('drbfm.history.statusDraft', '下書き');
    default:
      return status;
  }
};
